import { heroContent } from "@/mocks/homeData";

const heroBgImage = "https://readdy.ai/api/search-image?query=Abstract%20geometric%20network%20visualization%20with%20flowing%20data%20streams%2C%20warm%20olive%20green%20and%20cream%20gradient%20tones%2C%20modern%20technology%20background%2C%20soft%20glowing%20nodes%20interconnected%20with%20elegant%20lines%2C%20minimalist%20digital%20art%20style%2C%20clean%20aesthetic%20with%20subtle%20depth%2C%20professional%20tech%20company%20hero%20background%20with%20warm%20atmosphere%2C%20no%20text%20no%20people%2C%20abstract%20organic%20geometric%20shapes%20floating%20in%20warm%20light";

export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full h-screen min-h-[600px] max-h-[900px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${heroBgImage})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55" />

      <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/25 bg-white/10 backdrop-blur-sm mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
          <span className="text-white/90 text-xs md:text-sm font-medium tracking-wide">
            {heroContent.tagline}
          </span>
        </div>

        <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight max-w-4xl">
          {heroContent.title}
          <br />
          <span className="text-accent-400">{heroContent.titleHighlight}</span>
        </h1>

        <p className="mt-6 md:mt-8 text-white/75 text-base md:text-lg max-w-2xl leading-relaxed font-light">
          {heroContent.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8 md:mt-10">
          <a
            href="#services"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {heroContent.ctaText}
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-down-line text-sm"></i>
            </span>
          </a>
          <a
            href="#cta"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-white/30 text-white text-sm md:text-base font-medium hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {heroContent.ctaSecondary}
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </span>
          </a>
        </div>

        <div className="absolute bottom-8 md:bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
          <span className="text-white/50 text-xs tracking-widest uppercase">Scroll</span>
          <div className="w-5 h-8 rounded-full border border-white/25 flex items-start justify-center p-1">
            <div className="w-1 h-2 rounded-full bg-white/60 animate-bounce"></div>
          </div>
        </div>
      </div>
    </section>
  );
}